module.exports = __webpack_public_path__ + "img/tut3.fcb5780e.gif";